const translates = {
	en:{
		empty:"nothing found"
	},
	ru:{
		empty:"ничего не найдено"
	}
};

export default translates;